var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00413 6.00511C5.44824 6.561 4.78945 6.83366 3.99935 6.83366C3.20925 6.83366 2.55046 6.561 1.99457 6.00511C1.43868 5.44922 1.16602 4.79042 1.16602 4.00033C1.16602 3.21023 1.43868 2.55144 1.99457 1.99555C2.55046 1.43966 3.20925 1.16699 3.99935 1.16699C4.78945 1.16699 5.44824 1.43966 6.00413 1.99555C6.56002 2.55144 6.83268 3.21023 6.83268 4.00033C6.83268 4.79042 6.56002 5.44922 6.00413 6.00511Z",
    fill: "#EC0030",
    stroke: "#FFEFE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed);
export default __webpack_public_path__ + "static/media/red.02478a74ad818171dadb7d8f99bca350.svg";
export { ForwardRef as ReactComponent };